var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-progress-linear", {
        staticClass: "progressbar",
        attrs: {
          active: _vm.progressActive,
          indeterminate: _vm.progressIndeterminate,
          color: "primary",
          "background-color": "secondary",
          height: _vm.progBarHeight
        }
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "actors-headline", attrs: { flat: "" } },
        [
          _c("v-card-title", [
            _c("div", [_vm._v(_vm._s(_vm.activeActors.headline) + ":")]),
            _vm._v(" "),
            _c("div", { staticClass: "actor-category" }, [
              _vm._v(_vm._s(_vm.activeActors.label))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.switchActorArray(-1)
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "icon",
                    attrs: { icon: ["fas", "angle-left"] }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.switchActorArray(1)
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "icon",
                    attrs: { icon: ["fas", "angle-right"] }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "list-container",
          attrs: { flat: "", "max-height": _vm.maxHeight }
        },
        [
          [
            _vm._l(_vm.activeActors.data, function(i) {
              return _vm._t("default", null, { actor: i })
            })
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b1db3da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b1db3da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FactSheet_Actors.vue
// module id = null
// module chunks = 